import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SuitcaseFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M10.48 3.74H13.52C14.82 3.74 15.7 4.66 15.7 5.78V6.82H20.28V18.54H3.72V6.82H8.3V5.78C8.3 4.66 9.18 3.74 10.48 3.74ZM10.06 5.96V6.82H13.94V5.96C13.94 5.56 13.6 5.22 13.2 5.22H10.8C10.4 5.22 10.06 5.56 10.06 5.96Z" />
    </SvgIcon>
  );
});
